<template>
  <div class="create-ad-page">
    <create-ad-wizard :edit-ad-id="editAdId" />
  </div>
</template>

<script>
import CreateAdWizard from '@/features/ads/components/CreateAdWizard.vue'

export default {
  components: {
    CreateAdWizard,
  },
  computed: {
    editAdId() {
      return this.$route.params.id || null
    },
  },
}
</script>

<style lang="scss">
.create-ad-page {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2.5rem 1.5rem;
  box-sizing: border-box;

  @media (max-width: 767px) {
    padding: 0 1rem 1.25rem;
  }
}
</style>
